import React from 'react';
import { ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { umcodeURL } from '../../../../../../mol_function';

export interface MolLinkProp {
  children?: ReactNode;
  to: string;
  href: string;
  title?: string;
  inlinePadding?: boolean;
  orgHref?: string;
  inlineStyle?: React.CSSProperties;
  stopClickHandler?: (clickAction: () => void) => void;
  activStartWith?: boolean;
}

export default function MolLink(props: MolLinkProp) {
  let history = useHistory();
  //let state = { mouseOver: false };
  //style={{ display: 'inline', paddingLeft: '5px', paddingRight: '5px' }}
  let styleContainer: React.CSSProperties = {};

  if (props.inlineStyle != undefined) {
    styleContainer = { ...props.inlineStyle };
  }

  if (props.inlinePadding) {
    styleContainer.paddingInline = '5px';
  }

  let hreffAddParams: any = {};
  if (props.title != undefined) hreffAddParams.title = props.title;

  let linkSaveHreff = props.href;

  try {
    decodeURI(linkSaveHreff);
  } catch {
    linkSaveHreff = umcodeURL(linkSaveHreff);
  }

  let activ: boolean = false;
  try {
    let location = window.historyHelper.memory.location;
    let url = location.pathname + location.search;

    if (props.activStartWith == true) {
      activ = url.startsWith(props.to);
    } else {
      activ = url == props.to;
    }
  } catch {}

  let className = 'MolLink';

  if (activ) {
    className += ' activ';
  }

  return (
    <span
      className={className}
      style={styleContainer}
      onClick={(e) => {
        e.preventDefault();

        let clickHandle = () => {
          history.push(props.to, null);
        };

        if (props.stopClickHandler != undefined)
          props.stopClickHandler(clickHandle);
        else clickHandle();

        return true;
      }}
    >
      <a href={linkSaveHreff} {...hreffAddParams}>
        {props.children}
      </a>
    </span>
  );
}
